var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulkDeleteSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 9.833a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-8zm-14.667 2a1 1 0 0 0-.894.553l-4 8a1 1 0 0 0-.106.447v8A3.666 3.666 0 0 0 8 32.5h1.667v.32a1 1 0 0 0 1 1h3.945a1 1 0 0 0 1-1v-.32h8.721v.32a1 1 0 0 0 1 1h3.946a1 1 0 0 0 1-1v-.32h1.72a3.666 3.666 0 0 0 3.668-3.667v-8a1 1 0 0 0-.106-.447l-2-4a1 1 0 1 0-1.789.894l1.277 2.553H6.95l3-6h9.674a1 1 0 1 0 0-2H9.333zM29.28 30.5H8a1.667 1.667 0 0 1-1.667-1.667v-7h27.334v7A1.666 1.666 0 0 1 32 30.5h-2.721zm-15.946-5.667h-2.666V27.5h2.666v-2.667zm2.667 0h2.667V27.5H16v-2.667zm8 0h-2.667V27.5H24v-2.667zm2.667 0h2.666V27.5h-2.666v-2.667z",
    fill: "#A12512"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkDeleteSwitch);
export default __webpack_public_path__ + "static/media/bulkDeleteSwitch.59c8040609801600e28290ce32711437.svg";
export { ForwardRef as ReactComponent };